(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["account-sidebar"] && !Shopify.designMode) return;
  try {
    
// 文件：snippets/account-sidebar.liquid (内联脚本)

(function() {
  // 登出功能：设置cookie
  var logoutLink = document.querySelector('.logout-link');
  if (logoutLink) {
    logoutLink.addEventListener('click', function(e) {
      // 设置cookie标记用户已登出
      setCookie('rk_user_login', 'true', 7);
    });
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + d.toGMTString();
    document.cookie = name + '=' + value + '; ' + expires + '; path=/';
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-product-showcase"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const cards = document.querySelectorAll('.ro-pet-product-card');

    cards.forEach((card) => {
      card.addEventListener('focusin', function () {
        this.style.outline = '2px solid var(--main-color)';
        this.style.outlineOffset = '4px';
      });

      card.addEventListener('focusout', function () {
        this.style.outline = 'none';
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-product-swiper"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  function everyday() {
    var ScreenWidth = document.documentElement.clientWidth || window.innerWidth;
    var isPC = ScreenWidth > 1183;

    var maxHeight = 0;
    var swiperItems = document.querySelectorAll(".ro-pet-product-swiper .my-swiper-item");
    swiperItems.forEach(function(item) {
      var height = item.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });
    swiperItems.forEach(function(item) {
      item.style.height = maxHeight + 'px';
    });

    new Swiper("#everyday-features-swiper", {
      direction: "horizontal",
      centeredSlides: false,
      slidesPerView: "auto",
      spaceBetween: 16,
      grabCursor: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    function hideButton() {
      var buttons = document.querySelectorAll(".ro-pet-product-swiper .button-line > div");
      buttons.forEach(function(button) {
        button.style.display = "none";
      });
    }

    function showButton() {
      var buttons = document.querySelectorAll(".ro-pet-product-swiper .button-line > div");
      buttons.forEach(function(button) {
        button.style.display = "block";
      });
    }

    if (isPC) {
      hideButton();
      var swiperBlock = document.querySelector(".ro-pet-product-swiper .my-swiper-block");
      swiperBlock.addEventListener('mouseenter', showButton);
      swiperBlock.addEventListener('mouseleave', hideButton);
    }
  }

  everyday();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read base URL from data attribute
  var baseUrl = productRecommendationsSection.dataset.baseUrl;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = baseUrl + "?section_id=product-recommendations&limit=" + limit;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
    }
  };
  request.send();
};

// Listen for changes done in the Theme Editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roborock-account-dashboard"]) return;
  try {
    
  (function() {
    'use strict';
  
    class AccountDashboard {
      constructor() {
        this.container = document.querySelector('.account-dashboard');
        if (!this.container) return;
        
        this.init();
      }
  
      async init() {
        try {
          await Promise.all([
            this.loadCouponCount(),
            this.loadWishlistCount(),
            this.loadOrderStats(),
            this.loadRecommendations(),
            this.checkPointsExpiry()
          ]);
        } catch (error) {
          console.error('Dashboard初始化失败:', error);
        }
      }
  
      async loadCouponCount() {
        const element = document.querySelector('[data-coupon-count]');
        if (!element) return;
        
        try {
          const response = await fetch('/apps/coupons/count');
          if (!response.ok) throw new Error('Failed to fetch');
          
          const data = await response.json();
          element.textContent = data.count || 0;
        } catch (error) {
          console.error('加载优惠券数量失败:', error);
          element.textContent = '0';
        }
      }
  
      async loadWishlistCount() {
        const element = document.querySelector('[data-wishlist-count]');
        if (!element) return;
        
        try {
          const response = await fetch('/apps/wishlist/count');
          if (!response.ok) throw new Error('Failed to fetch');
          
          const data = await response.json();
          element.textContent = data.count || 0;
        } catch (error) {
          console.error('加载心愿单数量失败:', error);
          element.textContent = '0';
        }
      }
  
      async loadOrderStats() {
        const container = document.querySelector('[data-order-stats]');
        if (!container) return;
        
        try {
          const response = await fetch('/apps/orders/stats');
          if (!response.ok) throw new Error('Failed to fetch');
          
          const data = await response.json();
          this.updateOrderBadges(data.stats);
        } catch (error) {
          console.error('加载订单统计失败:', error);
        }
      }
  
      updateOrderBadges(stats) {
        if (!stats) return;
        
        const statusMap = {
          'pending_payment': stats.pending_payment || 0,
          'partially_fulfilled': stats.partially_fulfilled || 0,
          'fulfilled': stats.fulfilled || 0,
          'after_sales': stats.after_sales || 0
        };
  
        Object.keys(statusMap).forEach(status => {
          const count = statusMap[status];
          if (count > 0) {
            const card = document.querySelector('[href*="' + status + '"]');
            if (card) {
              const wrapper = card.querySelector('.status-icon-wrapper');
              if (wrapper && !wrapper.querySelector('.order-badge')) {
                const badge = document.createElement('span');
                badge.className = 'order-badge';
                badge.textContent = count;
                wrapper.appendChild(badge);
              }
            }
          }
        });
      }
  
      async loadRecommendations() {
        const container = document.querySelector('[data-recommendations-container]');
        if (!container) return;
        
        try {
          const response = await fetch('/recommendations/products.json?limit=6&intent=related');
          if (!response.ok) throw new Error('Failed to fetch');
          
          const data = await response.json();
          
          if (data.products && data.products.length > 0) {
            this.renderProducts(data.products, container);
          } else {
            container.innerHTML = '<p class="loading-placeholder">No recommendations available</p>';
          }
        } catch (error) {
          console.error('加载推荐商品失败:', error);
          container.innerHTML = '<p class="loading-placeholder">Failed to load</p>';
        }
      }
  
      renderProducts(products, container) {
        const html = products.map(product => {
          const price = this.formatMoney(product.price);
          return '<article class="product-card"><a href="' + product.url + '">' +
            '<img src="' + product.featured_image + '" alt="' + this.escapeHtml(product.title) + '" loading="lazy" width="200" height="200">' +
            '<h3>' + this.escapeHtml(product.title) + '</h3>' +
            '<p class="price">' + price + '</p>' +
            '</a></article>';
        }).join('');
        
        container.innerHTML = html;
      }
  
      checkPointsExpiry() {
        const notice = document.querySelector('[data-expiry-notice]');
        if (!notice) return;
        
        // TODO: 从API获取积分过期信息
        const expiringPoints = 0; // 默认不显示
        if (expiringPoints > 0) {
          notice.style.display = 'flex';
          const textEl = notice.querySelector('[data-expiry-text]');
          if (textEl) {
            textEl.textContent = expiringPoints + ' Point Expiring Soon';
          }
        }
      }
  
      formatMoney(cents) {
        return '$' + (cents / 100).toFixed(2);
      }
  
      escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
      }
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        new AccountDashboard();
      });
    } else {
      new AccountDashboard();
    }
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["world-cup-how-it-works"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const section = document.getElementById('shopify-section-{{ section.id }}');
    if (section) {
      section.classList.add('loaded');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
